import React from "react";

function FoodDefenseIncidents({emaIncidentArr}){
	let passedValues = emaIncidentArr.emaIncidentArr;
	return (
		<tbody>
			{passedValues && (
				passedValues.map((passedValue) => (
					<tr>
						<td style={{ width: "30%", verticalAlign: "top" }}>
							<div>
								<strong>Type of incident</strong>
								<br />
								{passedValue["type"].name}
							</div>
							<div>
								<strong>Number of illnesses</strong>
								<br />
								{passedValue["morbidity_range"]}
							</div>
							<div>
								<strong>Number of deaths</strong>
								<br />
								{passedValue["mortality_range"]}
							</div>
							<div>
								<strong>Year Began</strong>
								<br />
								{passedValue["year_began"]}
							</div>
							<div>
								<strong>Year Ended</strong>
								<br />
								{passedValue["year_ended"]}
							</div>
						</td>

						<td style={{ verticalAlign: "top" }}>
							<div>
								<strong>Incident summary</strong>
								<br />
								{passedValue["incident_summary"]}
							</div>
							<div>
								<strong>Adulterated food product(s)</strong>
								<br />
								{passedValue["adulterated_food_product_ingredient_resources"] && passedValue["adulterated_food_product_ingredient_resources"].length > 0 && (
									passedValue["adulterated_food_product_ingredient_resources"].map((adulteratedFood, adIdx) => (
										<>
											{adulteratedFood.name && (
												(adIdx > 0) ? ", " + adulteratedFood.name : adulteratedFood.name
											)}
										</>
									)))}
							</div>
							<div>
								<strong>Affected food product(s)</strong>
								<br />
								{passedValue["affected_food_product_ingredient_resources"] && passedValue["affected_food_product_ingredient_resources"].length > 0 && (
									passedValue["affected_food_product_ingredient_resources"].map((affectedFood, afIdx) => (
										<>
											{affectedFood.name && (
												(afIdx > 0) ? ", " + affectedFood.name : affectedFood.name
											)}
										</>
									)))}
							</div>
							<div>
								<strong>Originated location(s)</strong>
								<br />
								{passedValue["originated_locations"] && passedValue["originated_locations"].length > 0 && (
									passedValue["originated_locations"].map((origLoc, orgIdx) => (
										<>
											{origLoc.country_name && (
												(orgIdx > 0) ? ", " + origLoc.country_name : origLoc.country_name
											)}
										</>
									)))}
							</div>
							<div>
								<strong>Harm location(s)</strong>
								<br />
								{passedValue["harm_locations"] && passedValue["harm_locations"].length > 0 && (
									passedValue["harm_locations"].map((harmLoc, harmIdx) => (
										<>
											{harmLoc.country_name && (
												(harmIdx > 0) ? ", " + harmLoc.country_name : harmLoc.country_name
											)}
										</>
									)))}
							</div>
						</td>
					</tr>
				))
			)}
		</tbody>)
}

export default FoodDefenseIncidents;